@if (missingPhone || missingParking || missingHomeAccess) {
  <div class="top-stroke"></div>
}
@if (missingPhone) {
  <ion-row tappable (click)="goToAddressInfo()">
    <ion-col class="alert-icon">
      <ion-icon name="alert" />
    </ion-col>
    <ion-col class="button-text">
      <span>Missing Phone Number</span>
    </ion-col>
  </ion-row>
}
@if (missingParking) {
  <ion-row tappable (click)="goToAddressInfo()">
    <ion-col class="alert-icon">
      <ion-icon name="alert" />
    </ion-col>
    <ion-col class="button-text">
      <span>Missing Parking Instructions</span>
    </ion-col>
  </ion-row>
}
@if (missingHomeAccess) {
  <ion-row tappable (click)="goToAddressInfo()">
    <ion-col class="alert-icon">
      <ion-icon name="alert" />
    </ion-col>
    <ion-col class="button-text">
      <span>Missing Home Access Info</span>
    </ion-col>
  </ion-row>
}
